<template>
  <button :type="type" class="fomo-button" :class="rootClass">
    <span :class="prefix + '-glow'" aria-hidden="true"></span>
    <span v-if="variant === 'action'" :class="prefix + '-clip'" aria-hidden="true"><span :class="prefix + '-ring'"></span></span>
    <span v-else :class="prefix + '-ring'" aria-hidden="true"></span>
    <span v-if="variant === 'action'" :class="prefix + '-plate'" aria-hidden="true"></span>
    <span :class="prefix + '-inner'">
      <span :class="prefix + '-copy'"><slot /></span>
      <span v-if="icon" :class="prefix + '-icon'" aria-hidden="true"><i :class="icon"></i></span>
    </span>
  </button>
</template>
<script>
export default {
  name: 'FomoButton',
  props: {
    variant: { type: String, default: 'secondary', validator: v => ['primary', 'secondary', 'action'].includes(v) },
    type: { type: String, default: 'button' },
    icon: { type: String, default: 'fas fa-arrow-right' },
  },
  computed: {
    prefix() { return this.variant === 'action' ? 'event-view__action' : 'fomo-hero__action' },
    rootClass() { return [this.prefix, this.prefix + '--' + (this.variant === 'action' ? 'primary' : this.variant)] },
  },
}
</script>
